import { useMutation } from "@tanstack/react-query";
import { Eye, EyeOff, LockKeyhole, LogIn, UserRound } from "lucide-react";
import { FormEvent, useState } from "react";
import { api, jsonBody } from "../../api/client";
import { AppUser } from "../../api/types";
import { ErrorState } from "../../components/Feedback";
import { currentBrand } from "../../config/brand";

export function LoginScreen({ onAuthenticated }: { onAuthenticated(user: AppUser): void }) {
  const brand = currentBrand();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const login = useMutation({
    mutationFn: () => api<{ user: AppUser }>("/auth/login", { method: "POST", ...jsonBody({ username, password }) }),
    onSuccess: (data) => onAuthenticated(data.user),
  });

  function submit(event: FormEvent) {
    event.preventDefault();
    login.mutate();
  }

  return (
    <main className="login-page">
      <section className="login-panel" aria-labelledby="login-title">
        <img className="login-logo" src={brand.logo} alt={brand.name} />
        <div className="login-heading">
          <h1 id="login-title">{brand.productName}</h1>
          <p>Acesse com sua conta corporativa.</p>
        </div>

        <form className="login-form" onSubmit={submit}>
          <label>
            <span>E-mail do usuario</span>
            <span className="input-with-icon">
              <UserRound size={18} />
              <input autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)} required autoFocus />
            </span>
          </label>
          <label>
            <span>Senha</span>
            <span className="input-with-icon input-with-action">
              <LockKeyhole size={18} />
              <input
                type={showPassword ? "text" : "password"}
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
              <button type="button" className="input-action" onClick={() => setShowPassword((visible) => !visible)} aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}>
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </span>
          </label>

          {login.error ? <ErrorState message={login.error.message} /> : null}
          <button className="button button-primary login-button" type="submit" disabled={login.isPending}>
            <LogIn size={18} />
            {login.isPending ? "Entrando" : "Entrar"}
          </button>
        </form>

        <footer className="login-links">
          <a href="/privacidade.html" target="_blank" rel="noreferrer">Privacidade</a>
          <a href="/termos.html" target="_blank" rel="noreferrer">Termos de uso</a>
          <a href="/cookies.html" target="_blank" rel="noreferrer">Cookies</a>
          <a href="/retencao.html" target="_blank" rel="noreferrer">Retencao</a>
          <a href="mailto:privacidade@nspicinatto.com.br">Canal DPO</a>
        </footer>
      </section>
    </main>
  );
}
